import React from 'react'
import ButtonPremium from '../../ButtonPremium/ButtonPremium'

const ManagedSurveyButton = ({
  url,
  pollText,
  className = 'bottom-header'
}) => (
  <div className={`ManagedSurvey ${className}`}>
    <ButtonPremium
      onClick={event => {
        event.preventDefault()
        window.open(url)
      }}
      primary
    >
      {pollText.button_survey}
    </ButtonPremium>
  </div>
)

export default ManagedSurveyButton